export default "__VITE_ASSET__b2982107__"